'use strict';

var Css = require("bs-css-emotion/src/Css.bs.js");
var Curry = require("bs-platform/lib/js/curry.js");
var React = require("react");
var Mixins$FormBuilder = require("../../styles/Mixins.bs.js");
var Palette$FormBuilder = require("../../styles/Palette.bs.js");

function button(type_) {
  return Curry._1(Css.merge, {
              hd: Mixins$FormBuilder.flex_center_center,
              tl: {
                hd: Curry._1(Css.style, {
                      hd: Css.padding2(Css.em(type_ === /* Primary */0 ? 0.5 : 0.2), Css.em(type_ === /* Primary */0 ? 1.8 : 1)),
                      tl: {
                        hd: Css.fontSize(type_ === /* Primary */0 ? ({
                                  NAME: "rem",
                                  VAL: 2
                                }) : ({
                                  NAME: "rem",
                                  VAL: 1.5
                                })),
                        tl: {
                          hd: Css.backgroundColor(type_ ? ({
                                    NAME: "hex",
                                    VAL: Palette$FormBuilder.fgSecondary
                                  }) : ({
                                    NAME: "hex",
                                    VAL: Palette$FormBuilder.fgPrimary
                                  })),
                          tl: {
                            hd: Css.border({
                                  NAME: "px",
                                  VAL: 0
                                }, "none", Css.transparent),
                            tl: {
                              hd: Css.borderRadius(type_ === /* Primary */0 ? ({
                                        NAME: "em",
                                        VAL: 3
                                      }) : ({
                                        NAME: "em",
                                        VAL: 0.2
                                      })),
                              tl: {
                                hd: Css.fontWeight(type_ === /* Primary */0 ? "semiBold" : "normal"),
                                tl: {
                                  hd: Css.color({
                                        NAME: "hex",
                                        VAL: Palette$FormBuilder.textWhite
                                      }),
                                  tl: {
                                    hd: Css.transition(300, undefined, undefined, "background-color"),
                                    tl: {
                                      hd: Css.marginRight({
                                            NAME: "em",
                                            VAL: 1
                                          }),
                                      tl: {
                                        hd: Css.selector("& .icon", {
                                              hd: Css.paddingRight({
                                                    NAME: "em",
                                                    VAL: 1
                                                  }),
                                              tl: {
                                                hd: Css.border(Css.px(1), "solid", Css.red),
                                                tl: /* [] */0
                                              }
                                            }),
                                        tl: {
                                          hd: Css.selector("&:last-child", {
                                                hd: Css.marginRight({
                                                      NAME: "em",
                                                      VAL: 0
                                                    }),
                                                tl: /* [] */0
                                              }),
                                          tl: {
                                            hd: Css.selector("&:hover, &:focus", {
                                                  hd: Css.backgroundColor(type_ ? ({
                                                            NAME: "hex",
                                                            VAL: Palette$FormBuilder.fgSecondary_hover
                                                          }) : ({
                                                            NAME: "hex",
                                                            VAL: Palette$FormBuilder.fgPrimary_hover
                                                          })),
                                                  tl: /* [] */0
                                                }),
                                            tl: /* [] */0
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }),
                tl: /* [] */0
              }
            });
}

var Styles = {
  button: button
};

function Button(Props) {
  var onClick = Props.onClick;
  var icon = Props.icon;
  var text = Props.text;
  var type_Opt = Props.type_;
  var type_ = type_Opt !== undefined ? type_Opt : /* Primary */0;
  return React.createElement("button", {
              className: button(type_),
              onClick: onClick
            }, icon !== undefined ? React.createElement("span", {
                    style: {
                      maxHeight: "3rem",
                      paddingRight: "1em"
                    }
                  }, Curry._1(icon, undefined)) : null, text);
}

var make = Button;

exports.Styles = Styles;
exports.make = make;
/* Css Not a pure module */
